import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.types';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  // Falla rápido y con un mensaje claro en vez de un error críptico de
  // fetch más adelante — la causa casi siempre es un .env.local faltante.
  throw new Error(
    'Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copia .env.example a ' +
      '.env.local y completa los valores de tu proyecto de Supabase.',
  );
}

/**
 * Cliente único de Supabase para toda la aplicación. Nunca crear una
 * segunda instancia — ver ARQUITECTURA_FRONTEND.md, sección 4.
 *
 * Usa solo la clave pública (`anon key`); la seguridad real la aplica
 * Postgres vía Row Level Security (ver schema.sql, sección 13), así que
 * esta clave puede vivir en el bundle del navegador sin riesgo.
 */
export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
